import React, { useRef } from "react";
import { TooltipContainer } from "@outplayed/tooltips";
import { useTranslation } from "react-i18next";
import DefaultSelect from "components/DefaultSelect";

const Affix = (props) => {
  const tooltipRef = useRef();
  const { t } = useTranslation();
  const { className, isMobile, disabled, options, isDefault, onFilterChange, disableTooltip, selectedVal } = props;

  if (disabled) {
    return null;
  }

  return (
    <TooltipContainer
      ref={tooltipRef}
      tooltipInfo={t("Change Affix")}
      customClassName={className}
      disableTooltip={isMobile || disableTooltip}
    >
      <div>
        <DefaultSelect
          title={t("Change Affix")}
          group={"affix"}
          isMobile={isMobile}
          className={`filter-select filter-select_class ${isDefault}`}
          options={options}
          onChange={(selected) => {
            onFilterChange("affix", selected.value);
          }}
          value={selectedVal}
          width={170}
          isSearchable={false}
          onMenuClose={() => tooltipRef.current.forceClose()}
        />
      </div>
    </TooltipContainer>
  );
};

export default Affix;
